.Heading {
  color: var(--content-foundation-content-primary);
}

.Heading1 {
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-sm);
}

.Heading2 {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-lg);
}

.Heading3 {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-xl);
}

.Heading4 {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-3xl);
}

.Heading5 {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-2xl);
}

.Heading6 {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.6px;
  line-height: var(--line-height-md);
  text-transform: uppercase;
}

.Heading7 {
  color: var(--content-foundation-content-tertiary);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  letter-spacing: 0.6px;
  line-height: var(--line-height-md);
  text-transform: uppercase;
}
